// Indoor Football specific rules
// Phase 3: Deuce
import DeuceGood from "./general/kicks/deuce/deuce-good";
import DeuceGoodNotAffectedByPenalty from "./general/kicks/deuce/deuce-good-not-affected-by-penalty";
import DeuceMissed from "./general/kicks/deuce/deuce-missed";
import DeuceStats from "./general/kicks/deuce/deuce-stats";
// Phase 5: Rebound Net
import ReboundNetCaughtOffense from "./general/kicks/reboundnet/rebound-net-caught-offense";
import ReboundNetCaughtDefense from "./general/kicks/reboundnet/rebound-net-caught-defense";
import ReboundNetHitGround from "./general/kicks/reboundnet/rebound-net-hit-ground";
import ReboundNetFieldedKicking from "./general/kicks/reboundnet/rebound-net-fielded-kicking";
import ReboundNetFieldedReceiving from "./general/kicks/reboundnet/rebound-net-fielded-receiving";
import ReboundNetStats from "./general/kicks/reboundnet/rebound-net-stats";
import ReboundNetReturnStats from "./general/kicks/reboundnet/rebound-net-return-stats";
// Phase 5: Bar Ball
import BarBallRecoveredKicking from "./general/kicks/barball/bar-ball-recovered-kicking";
import BarBallRecoveredReceiving from "./general/kicks/barball/bar-ball-recovered-receiving";
import BarBallStats from "./general/kicks/barball/bar-ball-stats";
import BarBallReturnStats from "./general/kicks/barball/bar-ball-return-stats";
// Kickoff overrides
import IndoorKickOffOutOfBounds from "./general/kicks/kickoff/indoor-kick-off-out-of-bounds";
// Offensive overrides
import IndoorContinuedStats from "./offensive/indoor-continued-stats";
// General overrides
import IndoorPeriodStart from "./general/indoor-period-start";

const IndoorRules = Object.freeze({
    // Phase 3: Deuce scoring rules
    DeuceGood: new DeuceGood(),
    DeuceGoodNotAffectedByPenalty: new DeuceGoodNotAffectedByPenalty(),
    DeuceMissed: new DeuceMissed(),
    DeuceStats: new DeuceStats(),
    // Phase 4: Drop kick handled via isDropKick flag on PatKick/FieldGoal fragments
    // Phase 5: Rebound Net rules
    ReboundNetCaughtOffense: new ReboundNetCaughtOffense(),
    ReboundNetCaughtDefense: new ReboundNetCaughtDefense(),
    ReboundNetHitGround: new ReboundNetHitGround(),
    ReboundNetFieldedKicking: new ReboundNetFieldedKicking(),
    ReboundNetFieldedReceiving: new ReboundNetFieldedReceiving(),
    ReboundNetStats: new ReboundNetStats(),
    ReboundNetReturnStats: new ReboundNetReturnStats(),
    // Phase 5: Bar Ball rules
    BarBallRecoveredKicking: new BarBallRecoveredKicking(),
    BarBallRecoveredReceiving: new BarBallRecoveredReceiving(),
    BarBallStats: new BarBallStats(),
    BarBallReturnStats: new BarBallReturnStats(),
    // Kickoff overrides
    KickOffOutOfBounds: new IndoorKickOffOutOfBounds(),
    // Offensive overrides
    Offensive: Object.freeze({
        IndoorContinuedStats: new IndoorContinuedStats()
    }),
    // General overrides
    General: Object.freeze({
        IndoorPeriodStart: new IndoorPeriodStart()
    })
});

export default IndoorRules;
